export const assertDwToken = (token, param) => {
    param = typeof param  === "undefined" ? "" : param;
    const randomNumber = Math.floor((Math.random() * 10000) + 1);
    // TODO: add way to target correct url
    const imgUrl = siteGlobal.domains.PRODUCTS + "/Tokens?token=" + token + "&P1=" + param + "&r=" + randomNumber;

    if (document.images) {
        const gsTokenImage = new Image();
        gsTokenImage.src = imgUrl;
    }
}